import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import xls from "../../images/xls/png/Group 47.png"; 
import { UserContext } from "../../Contexts/UserContext";

const DownloadTrigger = ({ onClick }) => {

  const { getUser } = useContext(UserContext);


  const exportOption = getUser()?.export_option;

  if (exportOption !== "2"){
    return (
      <Tooltip title="Download via Email" placement="topLeft">
        <RiMailDownloadLine
          className="h-6 w-7 mt-1 cursor-pointer text-[#bc8b20]"
          onClick={onClick}
        />
      </Tooltip>
    );
  }

  return (
    <img
      src={xls}
      className="h-[24px] mt-1 w-[21px] cursor-pointer"
      alt="Export"
      onClick={onClick}
    />
  );
};

export default DownloadTrigger;
